// Dashboard bundle entry point
// Imports all dashboard modules in dependency order

import htmx from "htmx.org"
window.htmx = htmx  // htmx-ext-sse + extensions read from the global

import { application } from '../controllers/application.js'
import '../controllers/index.js'

import './utils.js'
import './attachments.js'
import './main.js'
import './settings.js'
import './collaborator-search.js'
import './collaborator-role.js'
import './submission-modal.js'
